import { useReapitConnect } from '@reapit/connect-session'
import { Loader, MainContainer, PageContainer } from '@reapit/elements'
import React, { FC, Suspense, useEffect } from 'react'
import { Redirect, useLocation } from 'react-router'
import { Nav } from '../components/ui/nav/nav'
import { ContactsApiService } from '../platform-api/contacts-api'
import { PropertyApiService } from '../platform-api/property-api'
import { useAppDispatch, useAppSelector } from '../store'
import { setContact, setProperty } from '../store/slices/crm-slice'
import { fetchUserInfo } from '../store/slices/docusign-auth-slice'
import { reapitConnectBrowserSession } from './connect-session'

export type PrivateRouteWrapperProps = {}

export const PrivateRouteWrapper: FC<PrivateRouteWrapperProps> = ({ children }) => {
  const { connectSession, connectInternalRedirect } = useReapitConnect(reapitConnectBrowserSession)
  const location = useLocation()
  const currentUri = `${location?.pathname}${location?.search}`
  const dispatch = useAppDispatch()
  const { user } = useAppSelector((state) => state.docusignAuth)
  const { reapitVariables } = useAppSelector((state) => state.crm)

  const fetchContactDetail = (contactCode) => {
    ContactsApiService.getContactById(connectSession!, contactCode)
      .then((contactDetail) => {
        dispatch(setContact(contactDetail))
      })
      .catch((error) => console.log(String(error)))
  }

  const fetchPropertyDetail = (propertyCode) => {
    PropertyApiService.getPropertyById(connectSession!, propertyCode)
      .then((property) => {
        dispatch(setProperty(property))
      })
      .catch((error) => console.log(String(error)))
  }

  useEffect(() => {
    if (connectSession) {
      if (reapitVariables.cntCode) {
        fetchContactDetail(reapitVariables.cntCode)
      }

      if (reapitVariables.prpCode) {
        fetchPropertyDetail(reapitVariables.prpCode)
      }
    }
  }, [connectSession, reapitVariables])

  useEffect(() => {
    if (!user) {
      dispatch(fetchUserInfo())
    }
  }, [user])

  if (!connectSession) {
    return (
      <MainContainer>
        <PageContainer>
          <Loader label="Loading" fullPage />
        </PageContainer>
      </MainContainer>
    )
  }

  if (connectInternalRedirect && currentUri !== connectInternalRedirect) {
    return <Redirect to={connectInternalRedirect} />
  }

  if (!user) {
    return (
      <MainContainer>
        <PageContainer>
          <Loader label="Loading" fullPage />
        </PageContainer>
      </MainContainer>
    )
  }

  return (
    <MainContainer>
      <Nav />
      <Suspense fallback={<Loader label="Loading" fullPage />}>{children}</Suspense>
    </MainContainer>
  )
}

export default PrivateRouteWrapper
